/**
 * Step indices derived from `productOnboarding.steps.ts`.
 *
 * Tour branching in `useProductTourJoyride` must use these values so reordering steps in one place
 * does not desynchronize guard conditions.
 */
import { dashboardSteps, getJobDetailsTourStepIndexByKey } from './productOnboarding.steps';

export const JOB_DETAILS_TOUR_STEP_INDEX = {
  performanceToggle: getJobDetailsTourStepIndexByKey('performance-toggle'),
  performanceChart: getJobDetailsTourStepIndexByKey('performance-chart'),
  pipelineWorkspace: getJobDetailsTourStepIndexByKey('pipeline-workspace'),
  metaCvFromTable: getJobDetailsTourStepIndexByKey('meta-cv-from-table'),
  metaCvFromChart: getJobDetailsTourStepIndexByKey('meta-cv-from-chart'),
  addCv: getJobDetailsTourStepIndexByKey('add-cv'),
  moreActionsMenu: getJobDetailsTourStepIndexByKey('more-actions-menu'),
  publicCvUpload: getJobDetailsTourStepIndexByKey('public-cv-upload'),
  configureExamMenu: getJobDetailsTourStepIndexByKey('configure-exam-menu'),
  examConfigOverview: getJobDetailsTourStepIndexByKey('exam-config-overview'),
  examSectionTechnical: getJobDetailsTourStepIndexByKey('exam-section-technical'),
  helpRestartTour: getJobDetailsTourStepIndexByKey('help-restart-tour'),
} as const;

/** More-actions dropdown auto-advance (open menu → public CV step). */
export const JOB_DETAILS_MENU_STEP_INDEX = {
  openMoreActions: JOB_DETAILS_TOUR_STEP_INDEX.moreActionsMenu,
  publicCvUpload: JOB_DETAILS_TOUR_STEP_INDEX.publicCvUpload,
} as const;

export const DASHBOARD_TOUR_STEP_INDEX = {
  createJob: 0,
  stepperModalInfo: 1,
  /** "Your Jobs Appear Here" (must reopen stepper when backing up to the stepper step). */
  jobListings: 2,
  openJobToContinue: dashboardSteps.length - 1,
} as const;
